import { setMeta, checkRule } from '@/router/middleware'
import routerView from '@/views/promotions/routerView'


const All = () => import ('@/views/promotions/All')
const Banners = () => import ('@/views/promotions/Banners')
const Links = () => import ('@/views/promotions/Links')
const Create = () => import ('@/views/promotions/Create')
const Edit = () =>import ('@/views/promotions/Edit')
const Hint = () =>import ('@/views/promotions/Hint')


export default {
    path: 'promotions',
    redirect: 'promotions/type=all',
    component: routerView,
    children: [
        // all
        {
            path: 'type=all',
            name: 'promotions',
            component: All,
            meta: {
                middleware: [setMeta],
                labelTrans: 'promotion.plural',
                rules: {
                    promotion: ['read_any', 'read_group', 'read_own']
                },
            }
        },
        // banner
        {
            path: 'type=banner',
            name: 'promotions.types.banners',
            component: Banners,
            meta: {
                middleware: [setMeta],
                labelTrans: 'promotion.types_plural.banner',
                rules: {
                    promotion: ['read_any', 'read_group', 'read_own']
                },
            }
        },
        // link
        {
            path: 'type=link',
            name: 'promotions.types.links',
            component: Links,
            meta: {
                middleware: [setMeta],
                labelTrans: 'promotion.types_plural.link',
                rules: {
                    promotion: ['read_any', 'read_group', 'read_own']
                },
            }
        },
        {
            path: 'create',
            name: 'promotions.create',
            component: Create,
            meta: {
                labelTrans: 'promotion.create',
                middleware: [setMeta, checkRule],
                rules: {
                    promotion: ['write_any', 'write_group', 'write_own']
                },
            }
        },
        {
            path: 'edit/:id',
            name: 'promotions.edit',
            component: Edit,
            meta: {
                labelTrans: 'promotion.edit',
                middleware: [setMeta, checkRule],
                rules: {
                    promotion: ['write_any', 'write_group', 'write_own']
                },
            }
        },
    ]
}